const genders = [
  {
    label: "alle",
    value: "all",
  },
  {
    label: "gemischt",
    value: "mixed",
  },
  {
    label: "männlich",
    value: "male",
  },
  {
    label: "weiblich",
    value: "female",
  },
] as const;

export default genders;
